import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-book-open-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold text-white whitespace-nowrap">
                  36漫画网
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                36漫画网为您提供最全面的漫画在线阅读体验。咒术回战、海贼王、鬼灭之刃等热门漫画全集无删减，免费在线畅读。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">漫画分类</h4>
              <ul className="flex flex-col gap-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">热门推荐</h4>
              <ul className="flex flex-col gap-2">
                <li><a href="/article/jjk-ch271" className="text-sm text-background-400 hover:text-primary-400 transition-colors">咒术回战</a></li>
                <li><a href="/article/op-ch1120" className="text-sm text-background-400 hover:text-primary-400 transition-colors">海贼王</a></li>
                <li><a href="/article/ds-ch205" className="text-sm text-background-400 hover:text-primary-400 transition-colors">鬼灭之刃</a></li>
                <li><a href="/article/aot-ch139" className="text-sm text-background-400 hover:text-primary-400 transition-colors">进击的巨人</a></li>
                <li><a href="/article/csm-ch167" className="text-sm text-background-400 hover:text-primary-400 transition-colors">电锯人</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
                <li><Link to="/about#reputation" className="text-sm text-background-400 hover:text-primary-400 transition-colors">用户口碑</Link></li>
                <li><Link to="/about#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</Link></li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 36漫画网. 本站所有漫画均来自网络，版权归原作者所有。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">服务条款</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}